import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Form,
} from 'shards-react';
import { useForm } from 'react-hook-form';

import { FormGroup } from '../../components/common';
import { updateUser } from '../../store/actions/users';

const CustomerEditModal = ({ open, onClose, user }) => {
  const { firstName, lastName, email, contactNo, address, postal } = user;

  const dispatch = useDispatch();
  const { control, errors, handleSubmit } = useForm();
  const isLoading = useSelector(({ ui }) => ui.isLoading);

  const onSubmit = async (data) => {
    user.firstName = data.firstName;
    user.lastName = data.lastName;
    user.email = data.email;
    user.contactNo = data.contactNo;
    user.address = data.address;
    user.postal = data.postal;
    dispatch(updateUser(user.id, user));
  };

  return (
    <Modal centered open={open} toggle={onClose}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <ModalHeader>Customer Details</ModalHeader>
        <ModalBody>
          <Row>
            <FormGroup
              name="firstName"
              col={{ lg: '6' }}
              label="First Name"
              control={control}
              errors={errors}
              rules={{ required: 'Required field' }}
              defaultValue={firstName}
            />
            <FormGroup
              name="lastName"
              col={{ lg: '6' }}
              label="Last Name"
              control={control}
              errors={errors}
              rules={{ required: 'Required field' }}
              defaultValue={lastName}
            />
          </Row>
          <Row>
            <FormGroup
              name="email"
              col={{ lg: '12' }}
              label="Email"
              control={control}
              errors={errors}
              rules={{
                required: 'Email is required',
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: 'Invalid email address',
                },
              }}
              defaultValue={email}
            />
          </Row>
          <Row>
            <FormGroup
              name="contactNo"
              col={{ lg: '12' }}
              label="Contact"
              control={control}
              defaultValue={contactNo}
            />
          </Row>
          <Row>
            <FormGroup
              name="address"
              col={{ lg: '12' }}
              label="Address"
              control={control}
              defaultValue={address}
            />
          </Row>
          <Row>
            <FormGroup
              name="postal"
              col={{ lg: '12' }}
              label="Postal"
              control={control}
              defaultValue={postal}
            />
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" disabled={isLoading} theme="success">
            Save
          </Button>
          <Button
            type="button"
            disabled={isLoading}
            theme="secondary"
            onClick={onClose}
          >
            Close
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

CustomerEditModal.propTypes = {
  user: PropTypes.object,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
};

CustomerEditModal.defaultProps = {
  user: {},
  onClose: () => {},
};

export default CustomerEditModal;
